module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-4-e5f2b1297fe89ea2709d9a0f352965bf.jpg";